import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/Opensource-02.jpg";
import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchSettings } from "../../reduxSlices/settingSlices";
import "./navbar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const [showNav, setShowNav] = useState(false);
  const collapseRef = useRef(null);
  const [modalOpen, setModalOpen] = useState(false);

  const dispatch = useDispatch();
  const settings = useSelector((state) => state.settings.data);
  const loading = useSelector((state) => state.settings.loading);

  useEffect(() => {
    if (showNav) {
      collapseRef.current.style.height = `${collapseRef.current.scrollHeight}px`;
    } else {
      collapseRef.current.style.height = "0px";
    }
  }, [showNav]);

  const logout = () => {
    localStorage.clear();
    navigate("/login");
    setShowNav(false);
  };

  const handleClick = () => {
    setModalOpen(true);
  };

  const hasTechnicianPermission = localStorage.getItem("role") === "Technician";
  const isTokenExsist = localStorage.getItem("token") === null;

  const handleButtonClick = () => {
    if (loading) return; // Don't navigate if still loading
    const mainSetting = settings?.find((item) => item.Key === "Main");
    if (mainSetting) {
      navigate(mainSetting.Value ? "/VerifiyMobileNumber" : "/eidMubarak");
    } else {
      // Default behavior if settings aren't loaded yet
      navigate("/VerifiyMobileNumber");
    }
    setShowNav(false);
  };

  useEffect(() => {
    dispatch(fetchSettings());
  }, [dispatch]);

  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container">
        <Link className="image-box" to="/" onClick={() => setShowNav(false)}>
          <img src={Logo} alt="Company Logo" />
        </Link>
        <button
          className={`navbar-toggler ${showNav ? "" : "collapsed"}`}
          type="button"
          aria-controls="navbarNav"
          aria-expanded={showNav}
          aria-label="Toggle navigation"
          onClick={() => setShowNav(!showNav)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className={`collapse navbar-collapse ${showNav ? "show" : ""}`}
          id="navbarNav"
          ref={collapseRef}
        >
          {!localStorage.getItem("token") ? (
            <>
              <ul className="navbar-nav ms-auto mt-0 mb-0">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    aria-current="page"
                    to="/"
                    onClick={() => setShowNav(false)}
                  >
                    الصفحه الرئيسيه
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/aboutUs">
                    <button
                      className="nav-link"
                      aria-disabled="true"
                      onClick={handleButtonClick}
                    >
                      ما يميزنا
                    </button>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/contactUs">
                    <button
                      className="nav-link"
                      aria-disabled="true"
                      onClick={handleButtonClick}
                    >
                      تواصل معنا
                    </button>
                  </Link>
                </li>
                {hasTechnicianPermission && !isTokenExsist && (
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      aria-disabled="true"
                      to="/dashboard/newAppointment"
                      onClick={() => setShowNav(false)}
                    >
                      لوحه التحكم
                    </Link>
                  </li>
                )}
              </ul>
              <Link to="login" className="login-button">
                <button
                  className="button nav-button"
                  onClick={() => {
                    handleClick();
                    setShowNav(false);
                    setModalOpen(!modalOpen);
                  }}
                >
                  تسجيل الدخول
                </button>
              </Link>
            </>
          ) : (
            <>
              <ul className="navbar-nav ms-auto mt-0 mb-0">
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    aria-current="page"
                    to="/"
                    onClick={() => setShowNav(false)}
                  >
                    الصفحه الرئيسيه
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/aboutUs">
                    <button
                      className="nav-link"
                      aria-disabled="true"
                      onClick={handleButtonClick}
                    >
                      ما يميزنا
                    </button>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/contactUs">
                    <button
                      className="nav-link"
                      aria-disabled="true"
                      onClick={handleButtonClick}
                    >
                      تواصل معنا
                    </button>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    onClick={() => setShowNav(false)}
                    className="nav-link"
                    aria-disabled="true"
                    to="/dashboard/newAppointment"
                  >
                    لوحه التحكم
                  </Link>
                </li>
              </ul>
              <button className="logOut-button" onClick={logout}>
                تسجيل الخروج
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
